import PropTypes from 'prop-types'

import { AdasChip } from '@components/wrapper-components'

export const StatusInfo = ({ label, color, isDiscount = false }) => {
  const isOpen = color === 'primary'

  return (
    <AdasChip
      label={isDiscount ? `(${label})` : label}
      className={`rounded-badge ${isDiscount ? 'bg-error-light text-error' : isOpen ? 'bg-highlight-green text-primary' : 'bg-muted text-muted-foreground'}`}
      size='small'
    />
  )
}

StatusInfo.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.oneOf(['primary', 'secondary', 'default']).isRequired,
  isDiscount: PropTypes.bool
}
